<script>
import { mapActions } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    props: ['prop_edit'],
    components: {
        DatePicker
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            send: false,
            form: {
                id: '',
                checkbook_id: '',
                folio: '',
                date: '',
                reason: '',
                status: 1,
            }
        }
    },
    methods: {
        closedModal() {
            this.send = false;
            this.form.id = '';
            this.form.checkbook_id = '';
            this.form.folio = '';
            this.form.date = '';
            this.form.reason = '';
            this.$modal.hide('addCheckbookCancel');
        },
        async saveBuildings() {
            this.send = true;
            let form = this.form;
            // console.log(form);
            let _endpoint = '/checkbook_cancellation';
            if (form.id != "") {
                form._method = 'PUT';
                _endpoint = `/checkbook_cancellation/${form.id}`;
            }
            try {
                let { data } = await request.postMedia(_endpoint, form)
                if (data) {
                    this.successNotification(data.message);
                    this.closedModal();
                    Event.$emit('event-load-FoliosCheckbooks');
                    this.send = false;
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                    this.send = false;
                }
            }
        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    mounted() {
    },
    created() {
        Event.$on("event-show-addCheckbookCancel", (checkbook_id, folio) => {
            this.form.checkbook_id = checkbook_id;
            this.form.folio = folio;
            this.$modal.show('addCheckbookCancel');
        });
        Event.$on("event-show-showFoliosCheckbooksCancel", async (cancel) => {
            this.form.id = cancel.id;
            this.form.checkbook_id = cancel.checkbook_id;
            this.form.folio = cancel.folio;
            this.form.date = cancel.date;
            this.form.reason = cancel.reason;
            this.$modal.show('addCheckbookCancel');
        });
    }
}
</script>

<template>
    <modal v-bind:click-to-close="false" name="addCheckbookCancel" :width="'80%'" :height="'auto'">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Cancelar folio de cheque</h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12 mt-2">
                    <label>Fecha de cancelación :</label>
                    <date-picker v-model="form.date" valueType="format" :disabled="!prop_edit"></date-picker>
                    <div v-if="errors && errors.date" class="text-danger">{{ errors.date[0] }}</div>
                </div>

                <div class="col-md-12 mt-2">
                    <label>Motivo de cancelación :</label>
                    <textarea type="text" class="form-control" v-model="form.reason" rows="4" :disabled="!prop_edit"></textarea>
                    <div v-if="errors && errors.reason" class="text-danger">{{ errors.reason[0] }}</div>
                </div>

                <div class="col-md-12">
                    <hr>
                    <button :disabled="send" @click="saveBuildings()" class="btn float-right btn-outline-success" v-if="prop_edit">
                        <span v-if="send">
                            <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                        </span>
                        <span v-else>
                            <i class="fas fa-save"></i> Guardar
                        </span>
                    </button>
                    <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                        <i class="fas fa-undo-alt"></i>
                        Regresar
                    </button>
                </div>
            </div>
        </div>
    </modal>
</template>